import { io, Socket } from 'socket.io-client'

let socket: Socket | null = null

export function getOfficeSocket(): Socket {
  if (socket && socket.connected) return socket
  if (socket) {
    // Reuse a disconnected instance — let the consumer call connect() again.
    return socket
  }
  // Same origin in dev (vite proxies /socket.io); same origin in prod via nginx.
  socket = io('/office', {
    autoConnect: false,
    transports: ['websocket', 'polling'],
    // 每次（重新）連線都讀最新的 token：access token 只有 1 小時，
    // 斷線重連時要用續期後的新 token，不能沿用建立連線當下那一張
    auth: (cb) => cb({ token: localStorage.getItem('token') || '' }),
    // Keep the path default so vite proxy can match.
  })
  return socket
}

export function tearDownOfficeSocket(): void {
  if (socket) {
    socket.removeAllListeners()
    socket.disconnect()
    socket = null
  }
}
